import React from 'react';
import { styled } from '@compiled/react';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import Lozenge from '@atlaskit/lozenge';
import { gridSize } from '@atlassian/jira-common-styles';
import { ff } from '@atlassian/jira-feature-flagging';
import { useIntl } from '@atlassian/jira-intl';
import { GREY } from '@atlassian/jira-issue-epic-color';
import CardLozenge from '../../../lozenge';
import type { TextCustomField } from '../types';
import { messages } from './messages';

type Props = {
	field: TextCustomField;
	fixVersions?: number[];
};

export const CUSTOM_FIELD_FIX_VERSIONS = 'fixVersions';

export const TextFixVersionsCustomFieldContent = ({ field, fixVersions = [] }: Props) => {
	const { formatMessage } = useIntl();
	if (isNil(field) || isNil(field.text) || isEmpty(field.text)) {
		return null;
	}

	const versionsCount = ff('jsw.board.versions-display-fix_mybjv')
		? fixVersions.length
		: field.text.split(',').length;

	const versionLozenge = ff('jsw-tanuki-fit-and-finish-part-2_5q757') ? (
		<Container>
			<Lozenge>
				{versionsCount > 1
					? formatMessage(messages.multipleVersionsContent, { versionsCount })
					: field.text}
			</Lozenge>
		</Container>
	) : (
		// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
		<CardLozenge color={GREY}>
			{versionsCount > 1
				? formatMessage(messages.multipleVersionsContent, { versionsCount })
				: field.text}
		</CardLozenge>
	);

	return versionLozenge;
};

const Container = styled.span({
	maxWidth: '100%',
	display: 'flex',
	justifyContent: 'flex-start',
	alignItems: 'center',
	'& span': {
		lineHeight: `${gridSize * 2}px`,
	},
});
